const ZOOM_WORKER_WASM_NOT_READY_ERRORS = [
    // WASM bindings called too early. Their minified 1-3 char names change with every SDK release.
    /^(Uncaught )?TypeError: ([\w$]{1,3}|(Module\.)?_malloc) is not a function($|\. \(In )/,
    /^(Uncaught )?ReferenceError: (_malloc|writeArrayToMemory) is not defined$/,
    /^ReferenceError: Can't find variable: (_malloc|writeArrayToMemory)$/,
    // `Module.HEAP8.fill(0)` before the WASM memory exists (audio worker)
    /^(Uncaught )?TypeError: Cannot read properties of undefined \(reading 'fill'\)$/,
    /^TypeError: can't access property "fill", Module\.HEAP8 is undefined$/,
];

/**
 * Zoom Video SDK media workers handle some messages (close media, participant list updates) before
 * their WASM has loaded, and throw. Harmless: Zoom terminates or re-syncs the worker right after, so
 * these are logged instead of tracked (LW-35142). Wording differs per browser ("Uncaught " in Chromium only).
 */
export const isZoomWorkerWasmNotReadyError = (message: string): boolean => {
    return ZOOM_WORKER_WASM_NOT_READY_ERRORS.some((pattern) => pattern.test(message));
};
